// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_SERVICES = 'FETCH_SERVICES'
export const FETCH_OPNHRS = 'FETCH_OPNHRS'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// bookings.js
export const SAVE_DATE = 'SAVE_DATE'
export const SAVE_MONTH = 'SAVE_MONTH'
export const SAVE_BOOKINGS = 'SAVE_BOOKINGS'
export const REMOVE_BOOKINGS = 'REMOVE_BOOKINGS'
export const UPDATE_BOOKING = 'UPDATE_BOOKING'
export const SET_SHOW_CANCELED = 'SET_SHOW_CANCELED'
export const SET_ANY_FREE_SLOT = 'SET_ANY_FREE_SLOT'
export const SET_BEGIN_SLOT = 'SET_BEGIN_SLOT'
export const SET_END_SLOT = 'SET_END_SLOT'
